import styled from 'styled-components';

export const StepsContainer = styled.div`
  position: relative;
  height: 530px;
  display: flex;
  align-items: center;
  justify-content: center;
`;



// WEBPACK FOOTER //
// ./src/components/Auth0Animation/components/StepsWrapper/styled.js